import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'vfs-grid-view-new',
  templateUrl: './grid-view-new.component.html',
  styleUrls: ['./grid-view-new.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GridViewNewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
